/**
 * Whether the desktop sidebar is showing labels or just icons. A UI
 * preference, not user data, so it lives in localStorage — same reasoning as
 * `ThemeProvider`. Mobile ignores this entirely (it gets the slide-over
 * drawer instead), so this only ever matters at the `lg` breakpoint.
 */
import { useCallback, useState } from 'react';

const STORAGE_KEY = 'minirag-sidebar-collapsed';

function readStored(): boolean {
  return localStorage.getItem(STORAGE_KEY) === '1';
}

export function useSidebarCollapsed(): [boolean, (next: boolean) => void] {
  const [collapsed, setCollapsedState] = useState<boolean>(readStored);

  const setCollapsed = useCallback((next: boolean) => {
    localStorage.setItem(STORAGE_KEY, next ? '1' : '0');
    setCollapsedState(next);
  }, []);

  return [collapsed, setCollapsed];
}
